import { FeatureIslandMainWithBackGround } from "@/components/features/_layouts";
import { QuestionForMain } from "@/components/features/_layouts/island/main/question";
import { QuestionKeyVisuals } from "@/components/features/items/edit/_shared/ui/components/main/questions/key-visual/key-visuals/key-visuals";
import { QuestionMainKeyVisual } from "@/components/features/items/edit/_shared/ui/components/main/questions/key-visual/main-key-visual";

import { InputTextField } from "@/components/ui/form/fields/input-field/input-text";

import type { HotelSettingsHotelInfoFormModel } from "../../../../model/type";
import type { HotelSettingsHotelInfoFormModelMethodsType } from "../../../../model/usecase/use-create-form-model/methods";

type Props = {
	viewModel: HotelSettingsHotelInfoFormModel["ViewModel"];

	logoMethods: HotelSettingsHotelInfoFormModelMethodsType["logoMethods"];
	keyVisualMethods: HotelSettingsHotelInfoFormModelMethodsType["keyVisualMethods"];
	hotelSettingsHotelInfoFormModelMethods: HotelSettingsHotelInfoFormModelMethodsType["hotelSettingsHotelInfoFormModelMethods"];
};

export const HotelSettingsHotelInfoBaseSettingsIsland = ({
	viewModel,
	logoMethods,
	keyVisualMethods,
	hotelSettingsHotelInfoFormModelMethods,
}: Props) => {
	return (
		<FeatureIslandMainWithBackGround islandTitle="基本設定">
			<QuestionForMain
				required={true}
				title="施設名"
				inputChildren={
					<InputTextField
						value={viewModel.name.value}
						errorMessage={viewModel.name.error}
						handleChange={hotelSettingsHotelInfoFormModelMethods.onSetName}
					/>
				}
			/>
			<QuestionForMain
				required={true}
				title="施設のキャッチコピー"
				guide="入力例 <br />
				・「最果ての旅のオアシス」へようこそ。<br />
				・金沢・香林坊に佇む蒸留所併設のブティックホテル"
				inputChildren={
					<InputTextField
						value={viewModel.catchCopy?.value ?? ""}
						errorMessage={viewModel.catchCopy?.error}
						handleChange={hotelSettingsHotelInfoFormModelMethods.onSetCatchCopy}
					/>
				}
			/>
			<QuestionMainKeyVisual
				hasFeatureIslandCategoryContext={false}
				ownerID={viewModel.companyID}
				resourceID={viewModel.hotelID}
				mainKVLabel="施設ロゴ"
				mainKeyVisual={viewModel.logoImage}
				onSetMainKeyVisual={logoMethods.onSetMainKeyVisual}
				isEdited={logoMethods.isEdited}
				errorMessage={logoMethods.errorMessage}
			/>

			<QuestionMainKeyVisual
				hasFeatureIslandCategoryContext={false}
				ownerID={viewModel.companyID}
				resourceID={viewModel.hotelID}
				mainKeyVisual={viewModel.mainKeyVisual}
				onSetMainKeyVisual={keyVisualMethods.onSetMainKeyVisual}
				errorMessage={keyVisualMethods.errorMessageMainKV}
				isEdited={keyVisualMethods.isEditedMainKV}
			/>
			<QuestionKeyVisuals
				hasFeatureIslandCategoryContext={false}
				ownerID={viewModel.companyID}
				resourceID={viewModel.hotelID}
				keyVisuals={viewModel.keyVisuals}
				KVsErrorMessage={undefined}
				onSetKeyVisuals={keyVisualMethods.onSetKeyVisuals}
			/>
		</FeatureIslandMainWithBackGround>
	);
};
